import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useTradicionalGroupsChartsDataContext } from './hooks/useTradicionalGroupsChartsDataContext';

export const QuilombolaFamily = () => {
    const { chartData } = useTradicionalGroupsChartsDataContext();

    return (
        <Donut
            title={'Família Quilombola'}
            subtitles={chartData?.quilombolaFamily?.map(
                (item) => item.description
            )}
            chartData={chartData?.quilombolaFamily || []}
            colors={
                defaultColors.slice(0, chartData?.quilombolaFamily?.length) ||
                []
            }
            height={400}
        />
    );
};
